/**
 * Money formatting.
 *
 * ONE locale, everywhere. Mixing de-DE and en-US put "EUR 2.000" next to
 * "EUR 1,500" on the same screen - gotcha 5 in the migration plan, and the
 * fastest way to look unfinished. en-IE is English copy plus the euro, which is
 * what this product is.
 *
 * @module web/money
 */
export const MONEY_LOCALE = "en-IE";

export function fmtEur(cents: number): string {
  return "€" + (cents / 100).toLocaleString(MONEY_LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * The same euro, without the trailing ".00" on a round amount.
 *
 * The live page has both: `eur2` always shows two decimals so a fare reads as a
 * calculated number, and `eur` drops them when they are zero so a headline
 * price does not read as a receipt. Both go through the one locale.
 */
export function fmtEurCompact(cents: number): string {
  return "€" + (cents / 100).toLocaleString(MONEY_LOCALE, {
    minimumFractionDigits: cents % 100 ? 2 : 0,
    maximumFractionDigits: 2,
  });
}
